import { MatSort } from '@angular/material/sort';
import { SaleHorseRepoContactDto } from '../../models/sales/sale-contacts.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class SaleContactListDataSource extends MatDataSource<SaleHorseRepoContactDto> {

  public constructor(
    data: SaleHorseRepoContactDto[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }

  setFilterPredicate(): void {
    this.filterPredicate = (contacts: SaleHorseRepoContactDto, filterValue: string) => {
      return 'firstName,lastName,email,mobile,linkedLots'.split(',').some((key) => {
        return (
          contacts[key as keyof SaleHorseRepoContactDto] &&
          new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
            String(contacts[key as keyof SaleHorseRepoContactDto] ?? '')
          )
        );
      });
    };
  }
}
